module.exports = __webpack_public_path__ + "img/album21_27.848fc1c9.jpg";